var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("label", { staticClass: "font-weight-bold caption" }, [
    _c("input", {
      staticStyle: { "pointer-events": "none" },
      attrs: { onclick: "return false;", type: "checkbox" },
      domProps: { checked: _vm.checked }
    }),
    _vm._v("\n  " + _vm._s(_vm.label) + "\n")
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }